// 站点级 SEO 配置与运行时 meta 注入
// 说明：本项目为 Vue 2 SPA（history 模式），爬虫不执行 JS 时只能读到 index.html 的静态标签，
// 因此路由切换后的 title / description / keywords / robots / canonical / OG 由本模块统一维护。
const SITE_NAME = '氦闪科技'
// 站点域名来自 config/*.env.js 的 SITE_URL（默认 https://hiasoon.com）
const SITE_URL = (process.env.SITE_URL || 'https://hiasoon.com').replace(/\/+$/, '')
// 分享图使用 static/logo.png（构建后位于站点根路径 /static/logo.png）
const OG_IMAGE = SITE_URL + '/static/logo.png'

// 最小抓取原则：默认禁止收录，仅显式声明 index,follow 的页面允许抓取
export const ALLOWED_ROBOTS = 'index,follow'
export const DEFAULT_ROBOTS = 'noindex,nofollow'

export const DEFAULT_SEO = {
  title: '氦闪科技 - 数字基础设施与企业级技术服务',
  description:
    '合肥氦闪科技有限公司以软件工程能力，构建可演进、可连接、可持续的企业级数字服务，涵盖氦闪云开放 API 中台、IoT 物联网平台、硬件支持平台与私有化定制开发。',
  keywords:
    '氦闪科技,氦闪云,hiasoon,数字基础设施,企业级技术服务,氦闪中台,开放API平台,私有化定制开发',
  robots: DEFAULT_ROBOTS,
  path: '/'
}

function upsertMeta(key, content, useProperty) {
  if (!content) {
    return
  }
  const attr = useProperty ? 'property' : 'name'
  let el = document.head.querySelector(`meta[${attr}="${key}"]`)
  if (!el) {
    el = document.createElement('meta')
    el.setAttribute(attr, key)
    document.head.appendChild(el)
  }
  el.setAttribute('content', content)
}

function upsertCanonical(href) {
  let el = document.head.querySelector('link[rel="canonical"]')
  if (!el) {
    el = document.createElement('link')
    el.setAttribute('rel', 'canonical')
    document.head.appendChild(el)
  }
  el.setAttribute('href', href)
}

function absoluteUrl(path) {
  if (/^https?:\/\//.test(path)) {
    return path
  }
  return SITE_URL + (path.charAt(0) === '/' ? path : '/' + path)
}

export function applySeo(options) {
  const seo = Object.assign({}, DEFAULT_SEO, options)
  // 站点地图/规范链接不接受锚点（如 /#contact），统一裁掉 hash
  const url = absoluteUrl(String(seo.path).split('#')[0])

  document.title = seo.title
  upsertMeta('description', seo.description)
  upsertMeta('keywords', seo.keywords)
  upsertMeta('robots', seo.robots)

  upsertMeta('og:title', seo.title, true)
  upsertMeta('og:description', seo.description, true)
  upsertMeta('og:type', 'website', true)
  upsertMeta('og:url', url, true)
  upsertMeta('og:site_name', SITE_NAME, true)
  upsertMeta('og:locale', 'zh_CN', true)
  upsertMeta('og:image', OG_IMAGE, true)

  upsertMeta('twitter:card', 'summary')
  upsertMeta('twitter:title', seo.title)
  upsertMeta('twitter:description', seo.description)

  upsertCanonical(url)
}



// WEBPACK FOOTER //
// ./src/utils/seo.js